export default "__VITE_ASSET__Bad3P8ak__"